import {createActions} from 'client/framework';

export const subjectViewActions = createActions(null, [
  'RESET_STORE',
  'SET_ACTIVE_SUBJECT',
  'SET_BACK_BUTTON_PATH',
  'SET_SCROLL_POSITION'
]);
